import React, { useEffect, useRef, useState } from 'react';
import { Card } from 'react-bootstrap';
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import { apiGet, getApiBase } from '../../services/api';

export default function VerifyEmailConfirm() {
  const { id, hash } = useParams();
  const { search } = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const apiBase = getApiBase();
    if (!apiBase || !id || !hash) {
      setStatus('error');
      return undefined;
    }

    const path = `/api/v1/auth/email/verify/${encodeURIComponent(id)}/${encodeURIComponent(hash)}${search || ''}`;

    (async () => {
      try {
        const res = await apiGet(path);
        if (res.status === 200) {
          setStatus('success');
          window.setTimeout(() => {
            navigate('/login?verified=1', { replace: true });
          }, 2000);
          return;
        }
        if (res.status === 403) {
          setStatus('forbidden');
          return;
        }
        setStatus('error');
      } catch {
        setStatus('error');
      }
    })();

    return undefined;
  }, [hash, id, navigate, search]);

  return (
    <div className="rwm-auth bg-white" data-testid="rwm-verify-confirm">
      <div className="rwm-auth__card py-5">
        <Card className="border" style={{ borderColor: 'var(--rwm-border)' }}>
          <Card.Body className="p-4 text-center">
            {status === 'loading' ? <p className="text-muted mb-0">Verifying your email…</p> : null}
            {status === 'success' ? (
              <p className="text-success mb-0">Email verified! Redirecting…</p>
            ) : null}
            {status === 'forbidden' ? (
              <>
                <p className="text-danger mb-3">Invalid or expired verification link.</p>
                <Link to="/verify-email-pending" className="rwm-job-detail__browse-link text-decoration-none">
                  Resend verification email
                </Link>
              </>
            ) : null}
            {status === 'error' ? (
              <p className="text-danger mb-0">Something went wrong. Please try again.</p>
            ) : null}
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}
